import React from 'react';

export default class DataMapper extends React.Component {
	constructor(props) {
		super(props);
		this.state = { appIsMounted: null };
	}

	async componentDidMount() {
		await import('../utils/dataMapper');
		this.setState({
			appIsMounted: true
		});
	}

	render() {
		return this.state.appIsMounted ? <span /> : null;
	}
}

DataMapper.propTypes = {};
